import React, { FC, useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { routes } from '../../../../../utils/constants/routes';
import axiosInstance from '../../../../../utils/axios';
import AddEdit from '../../../CommonPage/AddEdit';
import { AddEditPaymentConfigForm } from './AddEditPaymentConfigurationForm';
import { URLS } from '../../../../../utils/constants/urls';
import strings from '../../../../../common/Translation/Translate';
import { getUserOrg } from '../../../AddUser/userService';

const AddEditpaymentConfiguration: FC = () => {
  const { id } = useParams() as any;
  const [organisations, setOrganisations] = useState<any>([]);
  const [pageResponse, setPageResponse] = useState<any>([]);
  const [paymentProviders, setPaymentProviders] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getInitialResponse = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(URLS.paymentConfigById(id));
      const setNewData = {
        ...data,
        organizationId: data?.organization?.value,
        paymentProvider: data?.paymentProvider?.value,
      };
      setPageResponse(setNewData);
    } catch (error: any) { }
    finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    (async () => {
      if (id) {
        await getInitialResponse();
      }
    })();
  }, [getInitialResponse, id]);

  const getPaymentProviders = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(URLS.paymentProviderDropdowns);
      const filter = data.map((item: any) => {
        return { label: item.name, value: item.id };
      });
      setPaymentProviders(filter);
    }
    catch { }
    finally {
      setLoading(false);
    }
  }, []);
  const getOrganisations = useCallback(async () => {
    try {
      const response = await getUserOrg();
      const filter = response?.map((item: any) => {
        return { label: item.name, value: item.id };
      });
      setOrganisations(filter);
    } catch (e) { }
  }, []);

  useEffect(() => {
    getOrganisations();
    getPaymentProviders();
  }, [getOrganisations, getPaymentProviders]);

  const pageConfig = {
    title: id ? strings.payment_config_title_edit : strings.payment_config_title_add,
    successMessage: id ? strings.common_update_message : strings.common_save_message,
    addEditApiUrl: id ? URLS.paymentConfigById(id) : URLS.addPaymentConfig,
    initialApi: URLS.paymentConfigById(id),
    formModel: AddEditPaymentConfigForm(strings, organisations, paymentProviders),
    navigateToPage: routes.paymentConfig,
    isCustomResponse: false,
  };
  return (
    <AddEdit pageLoading={loading} pageConfig={pageConfig} pageResponse={pageResponse} /*handleCustomResponse={handleCustomResponse}*/ />
  );
};
export default AddEditpaymentConfiguration;
